module.exports = __webpack_public_path__ + "img/fabrica-3.35270a29.jpeg";